<template>
    <div class="translation-key w-full flex justify-between gap-5 items-center">
        <div class="flex flex-1 items-center truncate capitalize">
            {{ item.label }}
        </div>

        <ArrowRight class="self-center"/>
        
        <div class="flex flex-1 justify-between items-center  gap-4">
            <FormulateInput 
                v-model="model"
                class="w-full" 
                type="text"
                outer-class="w-full" 
                input-class="border input-bordered rounded px-3 py-2 leading-none focus:border-primary-focus outline-none input border-box w-full mb-1" 
                label-class="font-medium text-sm" 
                help-class="text-xs mb-1 text-gray-600" 
                error-class="text-red-700 text-xs mb-1"
                :disabled="!checkPermission('localization.edit')"
            />
            <ChangelogIcon
                class="w-5 h-5 cursor-pointer"
                @click.stop="showValueLogs"
            />
        </div>
    </div>           
</template>

<script>
// TODO enable ChangelogIcon when API is ready

import ChangelogIcon from "@shared/assets/icons/changelog.svg";
import ArrowRight from "@shared/assets/long-arrow-right.svg";
import { checkPermission } from "@shared/utils/functions";

export default {
  name: 'TranslationKey',
  components: {
    ArrowRight,
    ChangelogIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  computed: {
    model: {
      get() {
        return this.item.value;
      },
      set(value) {
        if (!checkPermission('localization.edit')) return;

        this.$emit('change', {
          ...this.item,
          value: value,
        });
      }
    },
  },
  methods: {
    checkPermission,
    showValueLogs() {
      this.$emit('showValueLogs', this.item.id)
    },
  }
};
</script>
